import { combineReducers } from "redux";
import { CusReducer } from "./CusReducer";
import { teamsReducer } from "./teamsReducer";
import { loginReducer } from "./loginReducer";
import { loderReducer } from "./loaderReducer";
import { addCusReducer } from "./addCusReducer";
import { teamsAddMember } from "./teamsAddMember";
import { cusTeamsReducer } from "./cusTeamsReducer";
import { commonDataReducer } from "./commonDataReducer";
import { appReleaseReducer } from "./appReleaseReducer";
import { moderationReducer } from "./moderationReducer";
import { dashBoardQuickView } from "./dashBoardQuickReducer";
import { changPasswrdReducer } from "./changePasswordReducer";
import { dashBoardanalyticView } from "./dashBoardAnalyticReducer";
import { activityLogReducer } from "./activityLogReducer";
import { workFlowReducer } from "./workFlowReducer";
import { languageAndAuthReducer } from "./languageAndAuthReducer";

const rootReducer = combineReducers({
  loader: loderReducer, //loder
  CusPage: CusReducer, //add,delete,edit page action manage
  addCus: addCusReducer, //Do action create addCustomers
  teamsPage: teamsReducer, //teamsPage reducer
  loginPage: loginReducer, //handle by loging,forget,reset page action manage
  cusTeams: cusTeamsReducer, //customer page Teams member reducer
  addMember: teamsAddMember, //Add member
  commonData: commonDataReducer, //common
  appRelease: appReleaseReducer, //app release Reducer
  moderation: moderationReducer, //moderation
  dasBordQuickView: dashBoardQuickView, //quick over view
  changPasswrdReducer: changPasswrdReducer, //changePwdReducer
  dashBoardAnalyticView: dashBoardanalyticView, //analytic view
  activityLog: activityLogReducer, //activitylog list
  workFlow: workFlowReducer,
  languageAndAuth: languageAndAuthReducer,
});
export default rootReducer;
